enum BasketLineItemIssueEnum {
  NotFound,
  InsufficientClearanceStock = 'insufficientClearanceStockError',
}

export default BasketLineItemIssueEnum;
